import React from 'react';
import PropTypes from 'prop-types';

import { Field } from 'redux-form';

import OrderInformationSectionEmpty from 'components/workflow/OrderInformation/OrderInformationSectionEmpty';

import * as validate from 'utils/validate';

const OrderInformationPrescriberEmpty = ({
  onAddButtonClick,
  disabled,
  ...fields
}) => (
  <Field
    id="Prescriber ID"
    name="Prescriber ID"
    component={OrderInformationSectionEmpty}
    {...(fields['Primary Insurance ID'] && fields['Primary Insurance ID'].input.value)
      ? { validate: [validate.required] }
      : {}
    }
    title="Prescriber"
    text="There are no prescribers"
    type="prescriber"
    onAddButtonClick={onAddButtonClick}
    disabled={disabled}
  />
);

OrderInformationPrescriberEmpty.propTypes = {
  onAddButtonClick: PropTypes.func,
  disabled: PropTypes.bool,
};

OrderInformationPrescriberEmpty.defaultProps = {
  onAddButtonClick: () => {},
  disabled: false,
};

export default OrderInformationPrescriberEmpty;



// WEBPACK FOOTER //
// ./src/components/workflow/OrderInformation/OrderInformationPrescriber/OrderInformationPrescriberEmpty.js